import { Link } from 'react-router-dom';
import type { PersonalRating } from '../../api/types';

const ClockIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 3h10M7 21h10M8 3v2.5c0 2.2 4 3.8 4 6.5s-4 4.3-4 6.5V21M16 3v2.5c0 2.2-4 3.8-4 6.5s4 4.3 4 6.5V21" />
  </svg>
);

const SnowIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round">
    <path d="M12 2v20M2 12h20M4.9 4.9l14.2 14.2M19.1 4.9 4.9 19.1" />
  </svg>
);

const UpIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 19V5M5 12l7-7 7 7" />
  </svg>
);

function nextGameLabel(g: { startTime: string }): string {
  const d = new Date(g.startTime);
  const wd = ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'][d.getDay()];
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `Ближайший турнир · ${wd} ${hh}:${mm} →`;
}

/** Полоса декея в карточке рейтинга (RD1): 4 состояния. */
export function DecayBar({ decay }: { decay: NonNullable<PersonalRating['decay']> }) {
  switch (decay.state) {
    case 'warning':
      return (
        <div className="decay-bar decay-bar--warning">
          <span className="ic"><ClockIcon /></span>
          <div className="tx">
            Пропущено {decay.missedInRow} игры подряд — со следующей рейтинг начнёт снижаться.
            {decay.nextGame && (
              <Link className="decay-cta" to={`/tournaments/${decay.nextGame.id}`}>
                {nextGameLabel(decay.nextGame)}
              </Link>
            )}
          </div>
        </div>
      );
    case 'active':
      return (
        <div className="decay-bar decay-bar--warning">
          <span className="ic"><ClockIcon /></span>
          <div className="tx">
            Рейтинг ржавеет: −{decay.lostTotal} за {decay.missedInRow - 3} пропущенные игры.
            Запишись на игру — падение остановится.
            <Link className="decay-cta" to="/schedule">
              К турнирам →
            </Link>
          </div>
        </div>
      );
    case 'floor':
      return (
        <div className="decay-bar decay-bar--floor">
          <span className="ic"><SnowIcon /></span>
          <div className="tx">
            Рейтинг заморожен на минимуме доверия — ниже он не опустится. Одна игра — и он
            снова пойдёт вверх.
          </div>
        </div>
      );
    case 'returned':
      return (
        <div className="decay-bar decay-bar--returned">
          <span className="ic"><UpIcon /></span>
          <div className="tx">С возвращением! Рейтинг снова растёт — скилл не потерян, просто заржавел.</div>
        </div>
      );
    default:
      return null;
  }
}
